module.exports = __webpack_public_path__ + "img/icon-win.f61e60c7.svg";